import React, { Component } from 'react';
import { Button, Modal, ModalBody, Row, Col, Container, ModalHeader, ModalFooter } from 'reactstrap';
import Config from '../../Util/config';
import HttpUtil from '../../Util/httpUtil';
import BoasVindas from '../../Componente/Modais/BoasVindas';
import { ModalUploadContext } from '../../Providers/ModalUpload';

import './TermoUso.scss';

const isSimulacao = localStorage.getItem('isSimulacao') === 'true';

class TermoUso extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			step: 'Default',
			activeIndex: 0,
			termoAceito: true,
		};

		this.verificaTermoDeUso();
	}

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.salvarTermoDeUso();
		this.setState({ isOpen: false });
	};

	verificaTermoDeUso = () => {
		var url = `${Config.urls.API_URL_BASE}Acesso/VerificaTermoDeUso`;

		return new Promise(() => {
			HttpUtil.eco_GET(url).then(
				response => {
					this.setState({
						termoAceito: response.data,
					});

					if (this.state.termoAceito == false && !isSimulacao) {
						this.setState({
							isOpen: true,
						});
					}
				},
				() => {
					window.location = '/erro';
				},
			);
		});
	};

	salvarTermoDeUso = () => {
		if (this.state.termoAceito == false) {
			var url = `${Config.urls.API_URL_BASE}Acesso/SalvarTermoDeUso`;

			return new Promise(() => {
				HttpUtil.eco_POST(url).then(
					response => {
						this.setState({
							termoAceito: response.data,
						});

						this.BoasVindas.openModal();
					},
					() => {
						window.location = '/erro';
					},
				);
			});
		}
	};

	renderModal() {
		return (
			<div>
				<BoasVindas ref={modal => (this.BoasVindas = modal)} />
				<ModalUploadContext.Consumer>
					{modalUpload => {
						this.openModalUpload = modalUpload.openModal;
						modalUpload.onClosed = this.handleReload;
					}}
				</ModalUploadContext.Consumer>
				<Modal
					id="modal-termo-uso"
					centered={true}
					size="lg"
					isOpen={this.state.isOpen}
					onClosed={this.handleModalClosed}
					backdrop="static">
					<div className="modal-header">
						<Row className="modal-alinhamento-linha">
							<Col md={3}>
								<h5 className="modal-title">Termo de Uso</h5>
							</Col>
							<Col md={9}>
								<img alt="" src="/img/assinatura-acesso-ilimitado.png" />
							</Col>
						</Row>
					</div>
					<ModalBody>
						<div>
							<p>
								A ECONET EDITORA EMPRESARIAL LTDA (“ECONET”), empresa brasileira com sede em Curitiba/PR, no endereço Rua Gago Coutinho, 553, Bacacheri – Curitiba/PR, oferece produtos, incluindo aplicativos, plataformas e ferramentas tributárias, para aparelhos e dispositivos de forma online (“Produtos”).
							</p>
							<p>
								O EcoGNRE contempla a emissão da Guia GNRE Nacional (Apuração e Operação), DARE-SP e DUA-ES, com as regras previstas nas disposições legais em conformidade com as legislações estaduais, através dos dados informados na Nota Fiscal Eletrônica (NF-e), modelo 55, e no Conhecimento de Transporte Eletrônico (CT-e), modelo 57.
							</p>
							<p>
								A estrutura deste produto foi desenvolvida com base na legislação pertinente vigente em cada Unidade Federada, aliado, também, à expertise Econet.
							</p>
							<p>
								O Usuário deverá utilizar esta ferramenta em conformidade com a legislação aplicável, sendo de sua responsabilidade a correta informação dos dados e revisão dos resultados apresentados.
							</p>

							<p class="title"><strong>DEFINIÇÕES</strong></p>

							<p>
								<strong>Informação Confidencial</strong>: toda e qualquer referência à expressão “Informação Confidencial” deverá ser compreendida e interpretada como toda e qualquer informação, conhecimento ou dado, revelado ao Usuário, contendo ou não a expressão “Confidencial”, de maneira verbal, escrita ou de qualquer outro modo apresentado, de forma tangível ou intangível, dos quais venha a tomar conhecimento, ou que sejam descobertos pelo Usuário durante a execução de atividades inerentes ao uso do EcoGNRE, ou decorrentes dessa execução, ou fornecido ou divulgado pela Econet ao Usuário, segundo este Instrumento ou em relação a ele, ou a qualquer outro instrumento celebrado entre o Usuário e a Econet, a que, diretamente ou através de terceiros, venha ter acesso, conhecimento ou que venha a lhe ser confiado, incluindo, mas não se limitando a:
							</p>

							<ol class="ml-4">
								<li>
									obras literárias, programas de computador e/ou outras obras autorais, bem como quaisquer outras informações e conteúdos envolvendo direitos de propriedade intelectual da Econet, podendo incluir, mas não se limitando a: direitos autorais, marcas, know-how, segredos de negócio, desenhos industriais e/ou patentes; e/ou
								</li>
								<li>
									modelos e estratégias de negócio, decisões gerenciais, oportunidades de mercado, planos de marketing e comerciais, informações de natureza publicitária, estudos e/ou pesquisas de mercado; e/ou
								</li>
								<li>
									características, amostras, especificações e conceitos de produtos (pré-existentes, novos ou em desenvolvimento); e/ou
								</li>
								<li>
									informações referentes a operações, processos, planos ou intenções; e/ou
								</li>
								<li>
									informações sobre produção, instalações, equipamentos, dados, habilidades especializadas, projetos, métodos e metodologia, fluxogramas, especificações, componentes, fórmulas, amostras, diagramas, layouts de diagramação, desenhos, modelos, esquemas industriais, questionários, invenções, ideias, conceitos, procedimentos normativos, sistemas; e/ou
								</li>
								<li>
									listas de preços, listas de clientes, informações sobre negociações em andamento, informações cadastrais de clientes, fornecedores e/ou parceiros comerciais; e/ou
								</li>
								<li>
									e-mails e/ou outras correspondências; e/ou
								</li>
								<li>
									informações, demonstrações, apresentações, relatórios e/ou listas de natureza contábil, financeiro e/ou estatístico.
								</li>
							</ol>

							<p class="title"><strong>Tratamento de Dados (“Tratamento”)</strong></p>

							<p>
								toda operação realizada com dados pessoais, como as que se referem a coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração.
							</p>

							<p class="title"><strong>Dados Pessoais (“Dados Pessoais”)</strong></p>

							<p>
								são todas informações relacionadas à pessoa natural identificada ou identificável. Dentro dessa definição, encontram-se os nomes dos Usuários, endereço de e-mail, número de telefone e informações identificadoras (IDs) de dispositivos.
							</p>

							<p class="title"><strong>EcoGNRE</strong></p>

							<p>
								refere-se expressamente ao produto ali disponibilizado e oferecido ao Usuário.
							</p>

							<p class="title"><strong>1. ESCOPO</strong></p>

							<p>
								Estes Termos e Condições de Uso (doravante referenciados simplesmente como “Instrumento”) são aplicáveis a todos que acessarem, obtiverem uma cópia, fizerem download, e/ou utilizarem os Produtos da Econet, disponibilizados no site. Ressalta-se que não está autorizada a utilização do software se não obtido dos meios oficiais oferecidos pela empresa.
							</p>

							<p>
								A Econet concede licença pessoal, revogável, não exclusiva e intransferível para que o Usuário faça uso do EcoGNRE, considerando os propósitos de validação do valor do ICMS Substituição Tributária recolhido ou a recolher, de acordo com a legislação vigente, envolvendo as informações e/ou documentos inseridos no produto pelo Usuário. O Usuário não está autorizado a utilizar ou permitir que o EcoGNRE seja utilizado para finalidade diversa ao escopo do presente instrumento.
							</p>

							<p>
								Para a utilização de nossos produtos, é necessário que o Usuário nos conceda algumas permissões. Para tanto, é importante que esteja de acordo com as disposições integrais de nossos Termos e Condições de Uso e Política de Privacidade.
							</p>

							<p>
								Caso não esteja de acordo com o disposto nos documentos mencionados acima, ou venha a mudar de ideia ao longo de sua experiência junto à Econet, o Usuário terá o direito de excluir a sua conta. A exclusão de sua conta e a remoção de eventuais dados relacionados a esta se dará de acordo com os limites técnicos envolvidos nessas práticas, bem como observará o disposto na legislação aplicável e na Política de Privacidade.
							</p>

							<p class="title"><strong>2. ACESSO E USABILIDADE DO EcoGNRE</strong></p>

							<p>
								O produto será disponibilizado na área “Soluções Econet” do site da Econet, com acesso através de login e senha do cliente. A Econet prestará informações para a utilização do EcoGNRE, tanto para questões sistêmicas, quanto legislativas, sendo elas disponibilizadas por meios dos canais de consultoria (legislativo), Suporte Técnico (sistêmico), ou via manual e demais conteúdos disponibilizados sobre o assunto.
							</p>

							<p>
								O Usuário poderá contatar a Econet que disponibilizará auxílio e esclarecimento de dúvidas quanto à aplicação e utilização do produto através dos canais de comunicação dispostos pela Econet.
							</p>

							<p>
								O EcoGNRE foi homologado para uso em computadores que utilizem o navegador Google Chrome, na versão 6 ou superior. Assim, para o melhor funcionamento da plataforma, os Usuários deverão utilizar tal navegador.
							</p>

							<p>
								A utilização da ferramenta em navegadores não-homologados, como, mas não somente, Internet Explorer, Firefox, Safari, etc., ou acesso via dispositivos móveis, poderá ocasionar danos às informações. A Econet não se responsabiliza por danos, falhas, e/ou dificuldades no acesso ou uso da ferramenta no caso de uso de navegadores não homologados.
							</p>

							<p>
								Visando a constante atualização, assim como melhorias na funcionalidade e usabilidade da ferramenta, a Econet poderá retirar o EcoGNRE do ar, momentaneamente, impossibilitando o acesso do Usuário.
							</p>

							<p>
								Os acessos são de responsabilidade do Usuário da ferramenta, que deve tomar as devidas providências para garantir a confidencialidade da mesma, sendo seu <strong>uso restrito aos assinantes da Econet</strong>, e não sendo permitido o repasse quanto à sua utilização para terceiros.
							</p>

							<p>
								A Econet periodicamente realizará verificações e, caso constatada alguma irregularidade quanto ao seu uso, serão tomadas as devidas providências para fins de evitar o compartilhamento de acesso ou vazamento de informação.
							</p>

							<p class="title"><strong>3. ATUALIZAÇÕES</strong></p>

							<p>
								Visando promover uma melhor experiência aos Usuários no momento da utilização dos nossos produtos, podemos atualizar e/ou modificar o software, os termos do presente Instrumento e da Política de Privacidade para que eles reflitam as nossas práticas atuais, bem como estejam sempre em conformidade com a legislação aplicável.
							</p>

							<p>
								As alterações e atualizações realizadas no presente Instrumento serão devidamente comunicadas anteriormente à sua entrada em vigor, para que o Usuário tenha a oportunidade de analisar o seu conteúdo e optar pela sua permanência ou não na utilização de nossos produtos. Esperamos que o Usuário esteja sempre satisfeito com os resultados proporcionados pelos nossos produtos, entretanto, caso não venha a concordar com os nossos Termos e Condições de Uso, o Usuário terá toda a liberdade para excluir a conta a qualquer momento.
							</p>

							<p>
								Uma vez que os Termos atualizados entrem em vigor, o Usuário estará vinculado a eles se continuar utilizando nossos produtos.
							</p>

							<p>
								Ainda, ao baixar, acessar ou utilizar os nossos produtos e aplicativos, o Usuário está de acordo com o download e instalação de atualizações, melhorias e recursos necessários para o contínuo funcionamento e melhoria de nossos produtos.
							</p>

							<p class="title"><strong>4. PROPRIEDADE INTELECTUAL</strong></p>

							<p>
								A Econet permanecerá com a propriedade e titularidade de todos os direitos de propriedade intelectual, tais como patentes, desenhos industriais, marcas, direitos autorais, softwares, direitos sobre informações confidenciais, sobre o seu Software, eventuais melhorias, aprimoramentos e atualizações relacionados a este, bem como a todos os demais produtos passíveis de proteção pelo direito da Propriedade Intelectual.
							</p>

							<p>
								Dessa maneira, a Econet reserva para si todos os direitos de propriedade intelectual e o uso de tais direitos não expressamente autorizados neste contrato.
							</p>

							<p>
								Por exemplo, esta licença veta e não concede nenhum direito de:
							</p>

							<ul class="ml-4">
								<li>
									Copiar, vender, ceder, sublicenciar, publicar, copiar, alugar, virtualizar, sublicenciar, arrendar nem emprestar o login de acesso ao EcoGNRE;
								</li>
								<li>
									Contornar quaisquer restrições ou limitações técnicas do EcoGNRE;
								</li>
								<li>
									Fazer engenharia reversa, descompilar ou desmontar o EcoGNRE;
								</li>
								<li>
									Modificar, atualizar, combinar ou criar aplicativos derivados do EcoGNRE;
								</li>
								<li>
									Remover identificações, instruções ou quaisquer elementos do EcoGNRE ou avisos eventualmente constantes do EcoGNRE;
								</li>
								<li>
									Buscar e/ou obter o registro de qualquer marca, designação social, nome de domínio, outros sinais distintivos, software, obra artística, científica, literária e/ou qualquer outro ativo passível de proteção pelo direito da propriedade intelectual que reproduza ou imite os ativos de titularidade da Econet;
								</li>
								<li>
									Usar qualquer robô, indexador, mecanismo, tecnologia, aplicativo de pesquisa/recuperação de sites ou outro dispositivo para recuperar ou indexar qualquer parte do EcoGNRE ou coletar informações e/ou dados sobre os Usuários e/ou sobre o EcoGNRE para qualquer finalidade não autorizada; ou
								</li>
								<li>
									Transmitir vírus, worms, malwares ou qualquer item que ocasione problemas no sistema ou perante os demais Usuários.
								</li>
							</ul>

							<p class="title"><strong>5. VIGÊNCIA</strong></p>

							<p>
								Os presentes Termos e Condições de uso terão início de vigência na data de seu aceite pelo Usuário e vigorarão por prazo indeterminado, enquanto durar a utilização do EcoGNRE. Se o Usuário excluir ou se nós desativarmos sua conta, estes Termos serão encerrados como um acordo entre o Usuário e a Econet, mas as disposições sobre Confidencialidade e Direitos de Propriedade Intelectual, que por sua natureza permaneçam vigentes após o fim da relação entre as partes, permanecerão em pleno vigor.
							</p>

							<p class="title"><strong>6. RESPONSABILIDADE</strong></p>

							<p>
								A Econet fornece produtos com o objetivo de dispor, de maneira simplificada e facilitada, a cadeia tributária de acordo com a operação simulada. <strong>Portanto, a interpretação da legislação e dos procedimentos fiscais descritos são de inteira responsabilidade do Usuário, não recaindo qualquer responsabilidade à Econet quanto às interpretações equivocadas ou em desconformidade com o pretendido. Os produtos disponibilizados pela Econet não constituem, nem devem ser considerados como aconselhamento, opinião ou consulta tributária.</strong>
							</p>

							<p>
								A interpretação da legislação e dos procedimentos fiscais descritos são de <strong>inteira responsabilidade do Usuário</strong>, não recaindo qualquer responsabilidade à Econet quanto interpretações erradas, equivocadas ou em desconformidade com o pretendido.
							</p>

							<p>
								A inserção correta de dados e informações para a pesquisa no EcoGNRE é de total e exclusiva responsabilidade do Usuário. Em caso de prejuízo ou dano decorrente de erro, falha ou omissão dessas informações durante a pesquisa, a responsabilidade será inteiramente do Usuário, isentando a Econet de qualquer responsabilidade.
							</p>

							<p>
								Os acessos são de responsabilidade do utilizador da ferramenta, que deve tomar as devidas providências para garantir a confidencialidade da mesma, sendo seu <strong>uso restrito aos assinantes da Econet</strong>, e não sendo permitido o repasse quanto à sua utilização por terceiros.
							</p>

							<p>
								A Econet periodicamente realizará verificações e, caso constatada alguma irregularidade quanto ao seu uso, serão tomadas as devidas providências para fins de evitar o compartilhamento de acesso ou vazamento de informação.
							</p>

							<p>
								A Econet se compromete em não compartilhar as informações do Usuário de forma a respeitar as normas legais atinentes à matéria, respeitando as boas práticas e a governança. Porém, é de responsabilidade do Usuário a correta utilização dos acessos, garantindo assim que o sistema não seja utilizado por terceiros ou de maneira a prejudicar o correto funcionamento do EcoGNRE.
							</p>

							<p class="title"><strong>7. SEGURANÇA E GARANTIAS</strong></p>

							<p>
								A Econet tem compromisso com a segurança dos dados coletados, fazendo o esforço necessário para garantir a segurança e a privacidade de seus dados, sejam eles relacionados ao Usuário ou à utilização que faz de nossos produtos. A implementação de proteções técnicas e organizacionais adequadas se dá para a proteção de processamentos não-autorizados ou ilegais dos <strong>dados pessoais e/ou sensíveis</strong> e também contra qualquer invasão, perda, alteração ou vazamento não autorizado dessas informações.
							</p>

							<p>
								O EcoGNRE, cujo uso e acesso está sendo autorizado, assim o está no “estado em que se encontra”, não sendo imputável à Econet quaisquer responsabilidades sobre o uso, desempenho, interrupção ou falhas do produto. Assim, a Econet não será responsável pela ocorrência de eventuais danos aos dispositivos ou quaisquer danos diretos, indiretos, lucros cessantes, perda de dados, falhas em outros programas, interrupção do trabalho ou quaisquer outros danos causados pela instalação e/ou acesso ao EcoGNRE, haja vista que não temos como fornecer qualquer garantia de que o EcoGNRE funcionará de maneira sem interrupções, atrasos, imperfeições ou riscos de danos e/ou erros, sendo a nossa responsabilidade limitada à máxima extensão permitida pela legislação aplicável.
							</p>

							<p>
								Falhas, descontinuidade ou não funcionamento dos produtos provenientes de intervenções de terceiros, utilização irregular e/ou advindos de descumprimento de qualquer obrigação assumida pelo presente Termo e Condições de Uso, bem como àqueles decorrentes de caso fortuito ou força maior, falta de conectividade e/ou funcionamento anormal do dispositivo do Usuário, não poderá ser atribuída à Econet.
							</p>

							<p class="title"><strong>8. CONFIDENCIALIDADE</strong></p>

							<p>
								A plataforma Econet contém <strong>informações confidenciais</strong> da Econet, de seus fornecedores, Usuários, além de segredos do negócio. Logo, o Usuário reconhece que o dever de sigilo e confidencialidade ora assumidos deverá perdurar inclusive após o fim da relação com a Econet e seus fornecedores, e abrange informações e/ou dados presentes e futuros.
							</p>

							<p>
								Nesse sentido, ao concordar com os Termos e Condições de Uso em comento, o Usuário compromete-se a:
							</p>

							<ol class="ml-4">
								<li>
									manter os critérios de sigilo e confidencialidade quando utilizar-se de <strong>informações confidenciais</strong> de propriedade e/ou relacionadas à Econet, bem como com relação àqueles conteúdos, dados, informações e/ou conhecimentos inerentes à plataforma Econet, não podendo deles fazer uso senão para as específicas finalidades da execução dos usos permitidos pela Econet;
								</li>
								<li>
									reconhecer que as <strong>informações confidenciais</strong> sobre a Econet, seus clientes, fornecedores, obras, produtos, somente podem ser utilizados para a realização do objeto deste Instrumento. É terminantemente proibido revelar, armazenar, reproduzir e/ou distribuir, por qualquer meio ou forma, qualquer <strong>informação confidencial</strong> que o Usuário tenha tido acesso por conta do uso do software;
								</li>
								<li>
									após o término da relação entre as partes, parar de usar definitivamente ditas <strong>informações confidenciais</strong> e devolver ou destruir, imediatamente, quaisquer documentos, arquivos, materiais, ou cópias deles, que estiverem sob sua posse e que se referiram ou contenham ditas <strong>informações confidenciais</strong>.
								</li>
							</ol>

							<p>
								As obrigações de confidencialidade e uso restrito não se aplicam caso o Usuário possa comprovar inequivocamente que:
							</p>

							<ol class="ml-4">
								<li>
									a informação já era de domínio público ou que se tornou domínio público sem que seja por meio de violação do presente Instrumento;
								</li>
								<li>
									a informação já estava sob a sua posse anteriormente ao envio da informação pela Econet, conforme evidenciado por meio de registros escritos inequívocos;
								</li>
								<li>
									a revelação da informação seja exigida por lei, regras impostas por um órgão governamental ou decisão judicial, desde que não exista a possibilidade de adotar medidas ou recursos administrativos e judiciais; e o Usuário tenha notificado a Econet, previamente à revelação e imediatamente após tomar conhecimento da necessidade de revelar, a fim de permitir que a Econet também apresente medidas capazes de resguardar seus direitos.
								</li>
							</ol>

							<p>
								A quebra da confidencialidade estabelecida por meio deste Instrumento, devidamente comprovada, sem autorização expressa, possibilitará a imediata rescisão do presente. Neste caso, o Usuário estará sujeito, por ação ou omissão, ao pagamento ou recomposição de todas as perdas e danos sofridos pela Econet, os quais serão apurados em regular processo judicial ou administrativo.
							</p>

							<p class="title"><strong>9. PROTEÇÃO DE DADOS PESSOAIS</strong></p>

							<p>
								Em cumprimento à Lei n° 13.709/2018 (Lei Geral de Proteção de Dados (LGPD)), informamos que o uso do aplicativo pode acarretar no tratamento de dados pessoais, especialmente quanto a dados comerciais e financeiros do Usuário. Tais dados serão utilizados pela plataforma Econet para comunicação e com propósitos operacionais relacionados ao EcoGNRE, de acordo com o disposto na Política de Privacidade.
							</p>

							<p>
								No preenchimento inicial da ferramenta, são solicitados os dados da empresa destinatária, quais sejam: razão social, nome fantasia, CNPJ, Código do Regime Tributário (CRT) e UF, com a finalidade de identificação e validação do documento fiscal.
							</p>

							<p>
								Em relação ao arquivo XML, são necessários os dados referentes ao modelo da nota fiscal e data de emissão (grupo ID do arquivo XML), dados do emitente e do destinatário, dados dos produtos descritos na Nota Fiscal (grupo DET do arquivo XML), além das informações referentes aos valores presentes na Nota Fiscal.
							</p>

							<p>
								A finalidade da extração dos dados do arquivo XML é confirmar as informações preenchidas na ferramenta e a realização dos cálculos, as quais encontram-se fundamentadas no cumprimento do contrato firmando entre o USUÁRIO e a ECONET.
							</p>

							<p>
								Apenas esses dados são armazenados na ferramenta, sendo que as demais informações presentes no arquivo XML da nota fiscal são eliminadas ao final do seu processamento.
							</p>

							<p class="title"><strong>9.1. Termo de Confidencialidade</strong></p>

							<p>
								Exceto quando exigidos por força de lei, processo judicial ou administrativo, todas as informações e dados contidos nos arquivos e funcionalidades da ferramenta são mantidos em sigilo, com acesso restrito por senha e limitado ao Suporte Técnico prestado pela Econet ao Usuário.
							</p>

							<p class="title"><strong>9.2. Medidas de Segurança</strong></p>

							<p>
								A Econet se compromete em:
							</p>

							<ol class="ml-4">
								<li>
									não compartilhar as informações do Usuário, incluindo os documentos fiscais eletrônicos acessados pela ferramenta;
								</li>
								<li>
									restringir o acesso e armazenamento dos documentos, mediante senha e limitado ao Suporte Técnico prestado pela Econet ao Usuário;
								</li>
								<li>
									proteger as informações do Usuário e dados decorrentes das funcionalidades da ferramenta em conformidade com a LGPD, através das medidas técnicas razoáveis e tecnologias aplicáveis e disponíveis.
								</li>
							</ol>

							<p>
								A Econet recomenda que sejam adotadas pelo Usuário medidas de segurança em seu computador, como a instalação de programa antivírus e de firewall contra invasões.
							</p>

							<p class="title"><strong>10. PENALIDADES</strong></p>

							<p>
								Na eventualidade de ocorrer o descumprimento de algumas das disposições dos Termos e Condições de Uso em comento, podemos remover eventual conteúdo compartilhado pelo Usuário que viole estas disposições e, se aplicável, podemos adotar medidas contra sua conta.
							</p>

							<p>
								Podemos também desativar sua conta, caso o Usuário venha a reincidir na prática de violação dos presentes Termos e Condições de Uso ou, se incorrer na prática de violações graves, como é caso de infrações que envolvam <strong>informações confidenciais, dados sensíveis, dados pessoais</strong> ou <strong>direitos de propriedade intelectual</strong>.
							</p>

							<p>
								Como Usuário da plataforma EcoGNRE, reconhece que a violação à qualquer dispositivo destes Termos e Condições que implique no descumprimento às regras para utilização das <strong>informações confidenciais</strong> do EcoGNRE, não apenas representa infração contratual grave à relação havida entre a Econet e o Usuário, dando ensejo, de pleno direito, à resolução de todos os contratos celebrados existentes, sem prejuízo do pagamento, ou recomposição, de todas as perdas e danos incorridos pela Econet, como também caracteriza crime de concorrência desleal, tipificado no artigo 195 da Lei n° 9.279/96, sem prejuízo de eventual responsabilização por crimes contra a inviolabilidade dos segredos, conforme artigos 153 e 154 do Código Penal e/ou outras sanções de caráter civil e criminal, a serem apuradas em regular processo judicial e/ou administrativo.
							</p>

							<p class="title"><strong>11. LEI APLICÁVEL E JURISDIÇÃO</strong></p>

							<p>
								Estes Termos e Condições de Uso são regidos e interpretados em conformidade com as Leis do Brasil. A Econet e o Usuário desde logo elegem, de forma irrevogável e irretratável, o foro da Comarca da Cidade de Curitiba, Estado do Paraná, para dirimir quaisquer dúvidas ou controvérsias oriundas deste Instrumento, com a exclusão de qualquer outro, por mais privilegiado que seja.
							</p>

							<p class="title"><strong>12. DISPOSIÇÕES GERAIS</strong></p>

							<p>
								Adicionalmente ao disposto na Política de Privacidade, estes Termos e Condições de Uso constituem um acordo integral entre o Usuário e a Econet, concernente ao seu objeto, substituindo quaisquer representações, negociações ou entendimentos anteriores.
							</p>

							<p>
								A utilização do EcoGNRE pelo Usuário e a concordância com os presentes Termos e Condições não implica em nenhuma espécie de sociedade, associação, solidariedade obrigacional, nem em qualquer responsabilidade direta ou indireta, seja societária, comercial, tributária, trabalhista, previdenciária ou de qualquer outra natureza, nem em alienação ou sucessão, entre a Econet e o Usuário.
							</p>

							<p>
								A omissão ou tolerância por parte da Econet, em exigir o estrito cumprimento das disposições e condições deste Termo, não constituirá novação ou renúncia, nem afetará os seus direitos, que poderão ser exercidos a qualquer tempo.
							</p>

							<p>
								Estes Termos e Condições de Uso vinculam e asseguram o benefício das partes e de seus sucessores, cessionários, licenciados, herdeiros e empresas associadas, a qualquer título, em todas as suas cláusulas e condições.
							</p>

							<p>
								Ao concordar com os Termos e Condições de Uso, o Usuário declara e concorda que:
							</p>

							<ol class="ml-4">
								<li>
									está de acordo com o recebimento de envio de mensagens eletrônicas para o seu endereço do e-mail e/ou número do telefone celular (SMS, MMS ou via aplicativos de comunicação, como o WhatsApp), incluindo “push” e outros meios necessários a execução dos produtos contratados;
								</li>
								<li>
									na melhor forma de direito que na celebração deste instrumento, não houve lesão, dolo, coação física ou moral, erro e nenhum outro vício de consentimento que possa afetar a sua existência ou validade, estando as partes em total conformidade com os termos e condições neste ato ajustadas.
								</li>
							</ol>

							<p>
								Se qualquer cláusula e/ou disposição destes Termos e Condições de Uso tornar-se total ou parcialmente inválida, ilegal, inexequível ou omissa, nos termos da lei aplicável, tal condição não prejudicará a validade das demais cláusulas e condições dos presentes Termos e Condições de Uso, que continuarão em pleno vigor e efeito. Em qualquer hipótese, a Econet irá envidar seus melhores esforços para substituir a cláusula e/ou disposição inválida, ilegal, inexequível ou omissa, por outra de conteúdo similar e com os mesmos efeitos. A alteração e/ou atualização do presente Instrumento será objeto de comunicado por parte da Econet.
							</p>
							
							<p class="title"><strong>
									13. ACEITAÇÃO DO TERMO DE USO
							</strong></p>

							<p>
								Ao selecionar o checkbox ao lado, o Usuário declara ter lido, compreendido e confirma estar de acordo com todas as regras, condições e obrigações estabelecidas no presente Instrumento.
							</p>
						</div>
					</ModalBody>
					<ModalFooter>
						<Container>
							<Row className="justify-content-center">
								<Button color="info" onClick={() => this.closeModal()}>
									{this.state.termoAceito ? 'Fechar' : 'Eu li e concordo com o termo de uso'}
								</Button>
							</Row>
						</Container>
					</ModalFooter>
				</Modal>
			</div>
		);
	}

	render = () => this.renderModal();
}

export default TermoUso;
